<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Logi systemowe</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Logi systemowe</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5>Filtry</h5>
            <span class="ibox-toggle" @click="isFiltersOpen = !isFiltersOpen">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="formatRange"
                    range
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Logi systemowe</h5>
            <span class="ibox-toggle" @click="isMainOpen = !isMainOpen">
              <i :class="chevronMainClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  show-index
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "CubelogsList",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const store = useStore();
    const systemLogsData = computed(() => store.getters.getSystemLogsData);
    let headers = [
      { text: "Data", value: "timestamp", sortable: true, search: true },
      {
        text: "Typ",
        value: "type",
        sortable: true,
        search: true,
      },
      {
        text: "Opis",
        value: "description",
        sortable: true,
        search: true,
      },
      {
        text: "Stacktrace",
        value: "stack",
      },
    ];
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    let items = ref([]);
    let itemsAll = ref(0);
    const filterRangeDate = ref();
    const getSystemLogs = () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      store.dispatch("getSystemLogs", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
      });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getSystemLogs();
          isSearch.value = false;
        }, 1000);
      }
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "";
      getSystemLogs();
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    const formatRange = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    onMounted(() => {
      if (localStorage.getItem("systemlSearchValue") !== null) {
        searchValue.value = localStorage.getItem("systemlSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (
        localStorage.getItem("syslogsRangeDate") !== null &&
        localStorage.getItem("syslogsRangeDate") !== undefined
      ) {
        filterRangeDate.value = localStorage.getItem("syslogsRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }
      getSystemLogs();
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "systemlSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "syslogsRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getSystemLogs();
      }
    );

    watch(
      () => systemLogsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        getSystemLogs();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getSystemLogs();
          isSearch.value = false;
        }
      },
      {
        deep: true,
      }
    );

    return {
      headers,
      serverOptions,
      items,
      itemsAll,
      loading,
      searchValue,
      search,
      updateSort,
      isSearch,
      rowsPerPage,
      selectPage,
      resetFilters,
      setRowsPerPage,
      filterRangeDate,
      formatRange,
      isFiltersOpen,
      isMainOpen,
      chevronFiltersClass,
      chevronMainClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  position: relative;
}
.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 12px;
  cursor: pointer;
}
</style>
